import { Loading } from '@/components/Loading'
import { MKTU_CLASS_CATEGORY } from '@/models/Mktu'
import { MktuClassButton } from '@/shared/Mktu/components'
import { mainStore } from '@/domains/Account/store'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { observer } from 'mobx-react-lite'
import { FunctionComponent } from 'react'
import styles from './MktuClassList.module.scss'

interface IMktuClassListProps {
  selected: MktuClassStore['number'][]
  onSelect: (value: MktuClassStore['number']) => void
  onMouseEnter?: (mktuClassNumber: MktuClassStore['number']) => void
  onMouseLeave?: (mktuClassNumber: MktuClassStore['number']) => void
}

export const MktuClassList: FunctionComponent<IMktuClassListProps> = observer(
  ({ selected, onSelect, onMouseEnter, onMouseLeave }) => {
    if (
      mainStore.mktuClassesList.loader.loading ||
      mainStore.mktuClassesList.classes.length === 0
    ) {
      return <Loading withText={false} />
    }

    return (
      <div className={styles.classes}>
        <div className={styles.group}>
          <div className={styles.title}>Товары</div>
          <div className={styles.list}>
            {mainStore.mktuClassesList.mapClassesByType[
              MKTU_CLASS_CATEGORY.PRODUCT
            ].map((mktuClassStore) => (
              <MktuClassButton
                key={mktuClassStore.number}
                className={styles.item}
                classNumber={mktuClassStore.number}
                isSelected={selected.includes(mktuClassStore.number)}
                onClick={onSelect}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
              />
            ))}
          </div>
        </div>

        <div className={styles.group}>
          <div className={styles.title}>Услуги</div>
          <div className={styles.list}>
            {mainStore.mktuClassesList.mapClassesByType[
              MKTU_CLASS_CATEGORY.SERVICE
            ].map((mktuClassStore) => (
              <MktuClassButton
                key={mktuClassStore.number}
                className={styles.item}
                classNumber={mktuClassStore.number}
                isSelected={selected.includes(mktuClassStore.number)}
                onClick={onSelect}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
)
